import React, { useState } from 'react';
import './imagemTextoAba.css';

const View = ({ data }) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      className={`block imagem-texto-varia-block image-${data.image_position || 'left'}`}
    >
      <div className="imagem-texto-varia-inner">
        {hover ? (
          <svg
            onMouseLeave={() => setHover(false)}
            width="263"
            height="406"
            viewBox="0 0 263 406"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M260.16 208.44L183.21 231.35L178.53 215.41L255.47 192.5L260.16 208.44Z"
              fill="#F0EAD7"
            />
            <path
              d="M244.09 205.97L242.96 202.12L252.04 199.42L253.17 203.27L244.09 205.97Z"
              fill="#00B033"
            />
            <path
              d="M180.53 234.21L161.19 168.41L243.66 143.85L263 209.65L180.53 234.21ZM166.14 171.12L183.22 229.23L258.05 206.95L240.97 148.84L166.14 171.12Z"
              fill="#00B033"
            />
            <path
              d="M203.09 246.95L201.96 243.1L223.98 236.55L219.29 220.58L223.11 219.44L228.93 239.26L203.09 246.95Z"
              fill="#00B033"
            />
            <path
              d="M227.02 239.82L225.89 235.98L248.12 229.36L249.25 233.21L227.02 239.82Z"
              fill="#00B033"
            />
            <path
              d="M177.44 216.62L176.31 212.77L254.96 189.36L256.09 193.2L177.44 216.62Z"
              fill="#00B033"
            />
            <path
              d="M197.11 192.32L193.14 191.94L194.06 182.11L178.54 185.44L184.09 175.16L174.56 167.75L176.99 164.58L189.22 174.07L186.18 179.7L198.54 177.05L197.11 192.32Z"
              fill="#00B033"
            />
            <path
              d="M195.16 406H61.47L41.32 273.66H215.31L195.16 406ZM64.89 401.99H191.73L210.66 277.67H45.96L64.89 401.99Z"
              fill="#00B033"
            />
            <path
              d="M217.97 267.64H38.66V275.66H217.97V267.64Z"
              fill="#F0EAD7"
            />
            <path
              d="M219.96 277.67H36.67V265.64H219.96V277.67ZM40.65 273.66H215.97V269.65H40.65V273.66Z"
              fill="#00B033"
            />
            <path
              d="M83.49 222.52H71.04V209.99H83.49V222.52ZM75.02 218.51H79.5V214H75.02V218.51Z"
              fill="#00B033"
            />
            <path d="M20.73 220.02H12.26V228.54H20.73V220.02Z" fill="#F0EAD7" />
            <path
              d="M22.72 230.54H10.27V218.01H22.72V230.54ZM14.26 226.53H18.74V222.02H14.26V226.53Z"
              fill="#00B033"
            />
            <path
              d="M230.92 131.79H222.45V140.31H230.92V131.79Z"
              fill="#F0EAD7"
            />
            <path
              d="M232.91 142.31H220.46V129.78H232.91V142.31ZM224.44 138.3H228.92V133.79H224.44V138.3Z"
              fill="#00B033"
            />
            <path
              d="M213.98 56.0901H201.53V43.5601H213.98V56.0901ZM205.52 52.0801H210V47.5701H205.52V52.0801Z"
              fill="#00B033"
            />
            <path
              d="M120.35 85.16H107.9V72.63H120.35V85.16ZM111.88 81.15H116.36V76.64H111.88V81.15Z"
              fill="#00B033"
            />
            <path
              d="M105.41 45.5601H96.94V54.0801H105.41V45.5601Z"
              fill="#F0EAD7"
            />
            <path
              d="M107.4 56.0901H94.95V43.5601H107.4V56.0901ZM98.93 52.0801H103.41V47.5701H98.93V52.0801Z"
              fill="#00B033"
            />
            <path
              d="M174.14 153.34H161.69V140.81H174.14V153.34ZM165.67 149.33H170.15V144.82H165.67V149.33Z"
              fill="#00B033"
            />
            <path
              d="M109.39 125.77H100.92V134.29H109.39V125.77Z"
              fill="#F0EAD7"
            />
            <path
              d="M111.38 136.3H98.93V123.77H111.38V136.3ZM102.91 132.29H107.39V127.78H102.91V132.29Z"
              fill="#00B033"
            />
            <path
              d="M36.67 149.33H24.22V136.8H36.67V149.33ZM28.2 145.32H32.68V140.81H28.2V145.32Z"
              fill="#00B033"
            />
            <path
              d="M176.13 244.58H163.68V232.05H176.13V244.58ZM167.66 240.57H172.14V236.06H167.66V240.57Z"
              fill="#00B033"
            />
            <path
              d="M159.19 334.81L145.4 342.33L153.4 356.26L140.26 354.9L140.46 347.18L125.41 361.09L141.45 377.67L142.34 368.66L162.18 368.9L168.73 354.31L159.19 334.81Z"
              fill="#F0EAD7"
            />
            <path
              d="M117.6 370.18L118.41 354.42L102.43 354.02L110.44 343.44L116.88 347.64L110.38 327.8L90.51 332.6L97.43 335.82L87.14 354.98L96.1 368.21L117.6 370.18Z"
              fill="#F0EAD7"
            />
            <path
              d="M108.76 317.17L122.24 325.24L130.03 311.18L135.61 323.24L128.92 327.02L149.39 330.48L154.41 310.53L148.37 315.21L136.31 297.11L120.35 297.72L108.76 317.17Z"
              fill="#F0EAD7"
            />
            <path
              d="M150.19 333.37L125.06 326.63L132.38 322.38L128.42 315.74L121.57 327.34L105.38 317.75L118.99 294.64H138.54L148.84 312.56L156.36 306.88L150.19 333.36V333.37ZM135.4 325.25L147.25 328.43L149.98 316.72L147.64 318.49L137.36 300.61L130.74 311.82L137.89 323.8L135.4 325.24V325.25ZM110.84 316.33L120.17 321.85L133.88 298.64H121.25L110.84 316.32V316.33Z"
              fill="#00B033"
            />
            <path
              d="M143.07 381.14L123.47 362.41L141.94 343.98L141.89 352.49L149.58 352.4L143.09 340.59L159.49 331.36L172.44 354.85L162.57 371.83L142 371.73L143.07 381.13V381.14ZM129.2 362.35L137.86 370.63L137.53 367.71L158.05 367.81L151.78 356.4L137.89 356.56L137.91 353.67L129.2 362.36V362.35ZM148.5 342.15L161.48 365.78L167.85 354.81L157.94 336.84L148.49 342.16L148.5 342.15Z"
              fill="#00B033"
            />
            <path
              d="M121.15 371.59L94.46 371.29L84.69 354.25L94.96 336.31L86.31 332.59L112.18 324.73L118.94 350.01L111.62 345.75L107.89 352.52L121.3 352.69L121.15 371.6V371.59ZM96.77 367.3L117.19 367.53L117.28 356.64L90.46 356.29L96.77 367.3ZM90.41 352.28L103.37 352.45L110.11 340.23L112.59 341.67L109.4 329.75L97.96 333.23L100.65 334.39L90.41 352.28Z"
              fill="#00B033"
            />
            <path
              d="M141.26 48.0699H134.29V59.0999H141.26V48.0699Z"
              fill="#F0EAD7"
            />
            <path
              d="M79.48 121.92L17.24 104.41L19.44 96.51L81.67 114.03L79.48 121.92Z"
              fill="#F0EAD7"
            />
            <path
              d="M125.82 52.1099L125.4 48.1199L131.98 47.4199L132.39 51.4099L125.82 52.1099Z"
              fill="#00B033"
            />
            <path
              d="M126.65 60.0799L126.23 56.0899L132.81 55.3999L133.23 59.3899L126.65 60.0799Z"
              fill="#00B033"
            />
            <path
              d="M132.49 61.8999L130.73 45.1199L142.97 43.8199L144.73 60.5999L132.49 61.8999ZM135.11 48.6799L136.03 57.4899L140.35 57.0299L139.43 48.2199L135.11 48.6799Z"
              fill="#00B033"
            />
            <path
              d="M160.75 110.08L159.97 102.65L167.91 101.81L168.69 109.24L160.75 110.08Z"
              fill="#F0EAD7"
            />
            <path
              d="M158.97 112.28L157.78 100.87L169.68 99.61L170.87 111.02L158.97 112.28ZM162.16 104.44L162.52 107.88L166.5 107.46L166.14 104.02L162.16 104.44Z"
              fill="#00B033"
            />
            <path
              d="M164.54 125.42L162.86 109.31L166.82 108.89L168.09 121.02L189.23 118.77L186.2 89.86L155.49 93.11L152.88 68.19L190.43 64.2L188.87 49.25L143.39 54.07L142.97 50.08L192.41 44.84L194.81 67.77L157.26 71.76L159.04 88.71L189.75 85.45L193.61 122.34L164.54 125.42Z"
              fill="#00B033"
            />
            <path
              d="M89.49 141.87L0 115.31L15.69 86.41L19.18 88.33L5.87 112.87L85.56 136.52L85.86 108.25L89.84 108.29L89.49 141.87Z"
              fill="#00B033"
            />
            <path
              d="M83.2 125.27L13.72 104.92L19.21 93.97L83.11 112.93L83.21 125.26L83.2 125.27ZM19.43 102.42L79.17 119.91L79.14 115.94L21.26 98.76L19.43 102.42Z"
              fill="#00B033"
            />
            <path
              d="M66.97 63.84L60.35 61.87L61.48 58.03L68.09 59.99L66.97 63.84Z"
              fill="#00B033"
            />
            <path
              d="M51.98 123.87L39.94 120.29L41.07 116.44L53.11 120.02L51.98 123.87Z"
              fill="#00B033"
            />
            <path
              d="M43.5163 52.2394L43.4827 56.2493L49.9024 56.3031L49.936 52.2932L43.5163 52.2394Z"
              fill="#00B033"
            />
            <path
              d="M41.99 66.75L38.18 65.6L39.23 62.07L37.6 59.07L41.1 57.15L43.52 61.62L41.99 66.75Z"
              fill="#00B033"
            />
            <path
              d="M41.64 63.8299L41.11 59.8599L46.97 59.0699L47.5 63.0499L41.64 63.8299Z"
              fill="#00B033"
            />
            <path
              d="M29.27 67.43L28.5 61.5L32.46 60.99L33.22 66.91L29.27 67.43Z"
              fill="#00B033"
            />
            <path
              d="M89.2 110.76L14.96 88.73L23.95 58.04L29.71 59.07L34.54 53.46L38.99 55.77L41.21 53.66L37.79 43.24L103.29 62.68L96.88 84.56L89.89 89.23L94.12 93.97L89.2 110.76ZM19.91 86.02L86.5 105.78L89.66 94.98L86.17 91.07L80.71 92.37L79.98 94.85L76.16 93.72L77.54 89.01L86.05 86.98L93.45 82.03L98.32 65.4L43.95 49.26L45.78 54.83L39.67 60.64L35.49 58.47L31.23 63.42L26.75 62.62L19.89 86.02H19.91Z"
              fill="#00B033"
            />
            <path
              d="M77.69 92.07L70.24 84.17L73.13 81.41L80.58 89.31L77.69 92.07Z"
              fill="#00B033"
            />
            <path
              d="M128.32 228.54H119.35V235.56H128.32V228.54Z"
              fill="#F0EAD7"
            />
            <path d="M54.6 174.4H35.67V189.44H54.6V174.4Z" fill="#F0EAD7" />
            <path
              d="M139.27 117.25L133.3 122.26L124.33 119.25L121.34 110.23L125.33 94.1899H135.29L145.25 101.21L139.27 117.25Z"
              fill="#F0EAD7"
            />
            <path
              d="M26.84 200.34L25.8 164.05L63.5401 162.95L64.59 199.24L26.84 200.34ZM29.9 167.94L30.72 196.21L60.5 195.34L59.68 167.07L29.9 167.94Z"
              fill="#00B033"
            />
            <path
              d="M34.22 192.47L33.64 172.32L56.19 171.66L56.77 191.81L34.22 192.47ZM37.74 176.21L38.09 188.34L52.68 187.91L52.33 175.78L37.74 176.21Z"
              fill="#00B033"
            />
            <path
              d="M32.9585 157.342L28.9801 157.457L29.2249 165.953L33.2032 165.838L32.9585 157.342Z"
              fill="#00B033"
            />
            <path
              d="M39.9398 157.142L35.9615 157.256L36.2062 165.753L40.1846 165.638L39.9398 157.142Z"
              fill="#00B033"
            />
            <path
              d="M46.8909 156.941L42.9125 157.056L43.1573 165.552L47.1356 165.438L46.8909 156.941Z"
              fill="#00B033"
            />
            <path
              d="M53.8523 156.741L49.8739 156.855L50.1186 165.352L54.097 165.237L53.8523 156.741Z"
              fill="#00B033"
            />
            <path
              d="M60.8136 156.54L56.8353 156.655L57.08 165.152L61.0584 165.037L60.8136 156.54Z"
              fill="#00B033"
            />
            <path
              d="M34.1567 198.98L30.1783 199.095L30.4231 207.591L34.4014 207.477L34.1567 198.98Z"
              fill="#00B033"
            />
            <path
              d="M41.1178 198.77L37.1394 198.884L37.3842 207.381L41.3625 207.266L41.1178 198.77Z"
              fill="#00B033"
            />
            <path
              d="M48.1091 198.559L44.1307 198.674L44.3755 207.17L48.3538 207.056L48.1091 198.559Z"
              fill="#00B033"
            />
            <path
              d="M55.0705 198.359L51.0921 198.474L51.3369 206.97L55.3152 206.855L55.0705 198.359Z"
              fill="#00B033"
            />
            <path
              d="M62.0116 198.159L58.0332 198.273L58.278 206.77L62.2563 206.655L62.0116 198.159Z"
              fill="#00B033"
            />
            <path
              d="M70.0558 165.315L61.6193 165.557L61.734 169.565L70.1706 169.324L70.0558 165.315Z"
              fill="#00B033"
            />
            <path
              d="M70.2564 172.317L61.8198 172.558L61.9346 176.567L70.3711 176.325L70.2564 172.317Z"
              fill="#00B033"
            />
            <path
              d="M70.4669 179.328L62.0304 179.57L62.1452 183.578L70.5817 183.336L70.4669 179.328Z"
              fill="#00B033"
            />
            <path
              d="M70.6674 186.339L62.2309 186.581L62.3457 190.589L70.7822 190.348L70.6674 186.339Z"
              fill="#00B033"
            />
            <path
              d="M70.8677 193.341L62.4312 193.582L62.5459 197.591L70.9825 197.349L70.8677 193.341Z"
              fill="#00B033"
            />
            <path
              d="M28.6974 166.519L20.2609 166.76L20.3756 170.769L28.8122 170.527L28.6974 166.519Z"
              fill="#00B033"
            />
            <path
              d="M28.908 173.53L20.4714 173.771L20.5862 177.78L29.0227 177.538L28.908 173.53Z"
              fill="#00B033"
            />
            <path
              d="M29.1082 180.531L20.6716 180.773L20.7864 184.781L29.2229 184.54L29.1082 180.531Z"
              fill="#00B033"
            />
            <path
              d="M29.3087 187.543L20.8722 187.784L20.987 191.793L29.4235 191.551L29.3087 187.543Z"
              fill="#00B033"
            />
            <path
              d="M29.5093 194.554L21.0728 194.796L21.1875 198.804L29.6241 198.562L29.5093 194.554Z"
              fill="#00B033"
            />
            <path
              d="M48.16 256.86L42.42 254.97C38.78 253.77 36.79 249.83 37.98 246.16L40.93 237.08L42.33 232.76C43.52 229.09 47.44 227.09 51.08 228.29L56.82 230.18C60.46 231.38 62.45 235.32 61.26 238.99L59.86 243.31L56.91 252.39C55.72 256.06 51.8 258.06 48.16 256.86Z"
              fill="#F0EAD7"
            />
            <path
              d="M50.32 259.22C49.39 259.22 48.45 259.07 47.53 258.77L41.79 256.88C37.11 255.34 34.54 250.25 36.07 245.54L40.42 232.14C41.16 229.86 42.74 228 44.87 226.91C47 225.82 49.42 225.64 51.69 226.38L57.43 228.27C62.11 229.81 64.68 234.9 63.15 239.61L58.8 253.01C58.06 255.29 56.48 257.15 54.35 258.24C53.08 258.89 51.7 259.22 50.32 259.22ZM48.92 229.94C48.15 229.94 47.39 230.12 46.69 230.48C45.51 231.08 44.64 232.11 44.22 233.38L39.87 246.78C39.02 249.39 40.44 252.21 43.04 253.06L48.78 254.95C50.04 255.37 51.38 255.26 52.56 254.66C53.74 254.06 54.61 253.03 55.03 251.76L59.38 238.36C60.23 235.75 58.81 232.93 56.21 232.08L50.47 230.19C49.96 230.02 49.44 229.94 48.93 229.94H48.92Z"
              fill="#00B033"
            />
            <path
              d="M52.44 240.34L48.65 239.09L50.51 233.37L54.3 234.62L52.44 240.34Z"
              fill="#00B033"
            />
            <path
              d="M136.06 126.07L120.18 121.6L120.82 119.62C121.36 117.93 121.74 115.06 121.06 114.11C118.47 110.48 118.44 102.31 122.3 96.8C124.15 94.15 128.35 90.16 136.18 91.8V91.75C136.46 91.82 136.72 91.9 136.98 91.98C137.24 92.05 137.5 92.12 137.77 92.19V92.24C145.3 94.93 146.83 100.53 147.05 103.76C147.51 110.48 143.27 117.45 139.19 119.2C138.1 119.67 136.96 122.31 136.55 124.04L136.07 126.07H136.06ZM125.12 118.83L133.27 121.12C133.98 119.18 135.34 116.49 137.62 115.51C140.06 114.47 143.42 109.19 143.07 104.03C142.8 100.03 140.39 97.28 135.91 95.84C131.34 94.72 127.86 95.82 125.56 99.1C122.6 103.33 122.76 109.59 124.3 111.76C125.74 113.78 125.52 116.79 125.13 118.83H125.12Z"
              fill="#00B033"
            />
            <path
              d="M134.87 133.03L117.6 128.17L120.55 117.55L137.82 122.41L134.87 133.03ZM122.51 125.39L132.1 128.09L132.9 125.19L123.31 122.49L122.5 125.39H122.51Z"
              fill="#00B033"
            />
            <path
              d="M128.79 134.44L122.08 132.55L123.95 125.79L130.67 127.68L128.79 134.44Z"
              fill="#00B033"
            />
            <path
              d="M134.24 109.67L126.33 101.61L134.47 98.9401L133.31 94.1401L137.18 93.1901L139.21 101.6L133.69 103.41L137.07 106.85L134.24 109.67Z"
              fill="#00B033"
            />
            <path
              d="M231.11 118.69L204.92 112.54L215.78 65.67L241.97 71.82L231.11 118.69Z"
              fill="#F0EAD7"
            />
            <path
              d="M231.93 120.67L201.54 113.54L213.32 62.71L243.71 69.84L231.93 120.67ZM206.32 110.54L228.95 115.85L238.92 72.83L216.29 67.52L206.32 110.54Z"
              fill="#00B033"
            />
            <path
              d="M221.77 109.92L215.37 108.42L216.28 104.52L222.68 106.02L221.77 109.92Z"
              fill="#00B033"
            />
            <path
              d="M227.44 73.31L222.16 72.07L220.59 67.88L224.32 66.47L225.14 68.66L228.35 69.41L227.44 73.31Z"
              fill="#00B033"
            />
            <path
              d="M231.22 74.2L225.94 72.96L226.84 69.06L230.05 69.81L231.74 68.21L234.47 71.14L231.22 74.2Z"
              fill="#00B033"
            />
            <path
              d="M142.082 175.159L100.315 177.633L100.611 182.635L142.378 180.16L142.082 175.159Z"
              fill="#F0EAD7"
            />
            <path
              d="M141.095 159.116L99.3284 161.59L99.6247 166.591L141.391 164.117L141.095 159.116Z"
              fill="#F0EAD7"
            />
            <path
              d="M93.63 257.37L87.41 150.8L150.06 147.09L156.28 253.66L93.63 257.37ZM91.61 154.57L97.37 253.13L152.06 249.9L146.3 151.34L91.61 154.58V154.57Z"
              fill="#00B033"
            />
            <path
              d="M96.51 169.97L95.86 158.82L142.6 156.05L143.25 167.2L96.51 169.97ZM100.07 162.58L100.25 165.72L139.03 163.43L138.85 160.28L100.07 162.58Z"
              fill="#00B033"
            />
            <path
              d="M97.41 185.41L96.76 174.26L143.5 171.49L144.15 182.64L97.41 185.41ZM100.97 178.02L101.15 181.17L139.93 178.88L139.75 175.73L100.97 178.02Z"
              fill="#00B033"
            />
            <path
              d="M109.53 254.48L106.03 252.55L109.37 246.43L139.16 244.66L145.66 251.18L142.85 254.02L137.61 248.77L111.81 250.3L109.53 254.48Z"
              fill="#00B033"
            />
            <path
              d="M108.34 217.83L92.65 211.06L94.22 207.37L109.04 213.77L136.52 212.14L150.31 204.35L152.26 207.85L137.67 216.09L108.34 217.83Z"
              fill="#00B033"
            />
            <path
              d="M123.9 239.5C120.18 239.5 117.05 236.57 116.83 232.78C116.6 228.85 119.59 225.47 123.49 225.24C127.41 224.99 130.75 228.02 130.98 231.94C131.21 235.87 128.22 239.25 124.32 239.48C124.18 239.48 124.04 239.49 123.9 239.49V239.5ZM123.91 229.24C123.85 229.24 123.79 229.24 123.73 229.24C122.02 229.34 120.71 230.82 120.81 232.54C120.91 234.26 122.38 235.54 124.09 235.48C124.92 235.43 125.68 235.06 126.23 234.44C126.78 233.82 127.06 233.01 127.01 232.18C126.91 230.52 125.54 229.24 123.91 229.24Z"
              fill="#00B033"
            />
            <path
              d="M144.472 188.083L97.7314 190.81L97.9651 194.814L144.706 192.086L144.472 188.083Z"
              fill="#00B033"
            />
            <path
              d="M98.43 3.94995H159.19V22H149.23V10.97H107.4V22H97.43L98.43 3.94995Z"
              fill="#F0EAD7"
            />
            <path
              d="M219.96 38.04H36.67V21H219.96V38.04ZM40.65 34.03H215.97V25.01H40.65V34.03Z"
              fill="#00B033"
            />
            <path
              d="M150.28 23H146.29V12.98H110.38V23H106.4V8.96997H150.28V23Z"
              fill="#00B033"
            />
            <path
              d="M162.27 23H158.28V4.01H98.74V23H94.76V0H162.27V23Z"
              fill="#00B033"
            />
          </svg>
        ) : (
          <svg
            onMouseEnter={() => setHover(true)}
            width="263"
            height="406"
            viewBox="0 0 263 406"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M244.09 205.97L242.96 202.12L252.04 199.42L253.17 203.27L244.09 205.97Z"
              fill="#00B033"
            />
            <path
              d="M180.53 234.21L161.19 168.41L243.66 143.85L263 209.65L180.53 234.21ZM166.14 171.12L183.22 229.23L258.05 206.95L240.97 148.84L166.14 171.12Z"
              fill="#00B033"
            />
            <path
              d="M203.09 246.95L201.96 243.1L223.98 236.55L219.29 220.58L223.11 219.44L228.93 239.26L203.09 246.95Z"
              fill="#00B033"
            />
            <path
              d="M227.02 239.82L225.89 235.98L248.12 229.36L249.25 233.21L227.02 239.82Z"
              fill="#00B033"
            />
            <path
              d="M177.44 216.62L176.31 212.77L254.96 189.36L256.09 193.2L177.44 216.62Z"
              fill="#00B033"
            />
            <path
              d="M197.11 192.32L193.14 191.94L194.06 182.11L178.54 185.44L184.09 175.16L174.56 167.75L176.99 164.58L189.22 174.07L186.18 179.7L198.54 177.05L197.11 192.32Z"
              fill="#00B033"
            />
            <path
              d="M195.16 406H61.4699L41.3199 273.66H215.31L195.16 406ZM64.8899 401.99H191.73L210.66 277.67H45.9599L64.8899 401.99Z"
              fill="#00B033"
            />
            <path
              d="M219.96 277.67H36.67V265.64H219.96V277.67ZM40.65 273.66H215.97V269.65H40.65V273.66Z"
              fill="#00B033"
            />
            <path
              d="M83.49 222.52H71.04V209.99H83.49V222.52ZM75.02 218.51H79.5V214H75.02V218.51Z"
              fill="#00B033"
            />
            <path
              d="M22.72 230.54H10.27V218.01H22.72V230.54ZM14.26 226.53H18.74V222.02H14.26V226.53Z"
              fill="#00B033"
            />
            <path
              d="M232.91 142.31H220.46V129.78H232.91V142.31ZM224.44 138.3H228.92V133.79H224.44V138.3Z"
              fill="#00B033"
            />
            <path
              d="M213.98 56.0901H201.53V43.5601H213.98V56.0901ZM205.52 52.0801H210V47.5701H205.52V52.0801Z"
              fill="#00B033"
            />
            <path
              d="M120.35 85.16H107.9V72.63H120.35V85.16ZM111.88 81.15H116.36V76.64H111.88V81.15Z"
              fill="#00B033"
            />
            <path
              d="M107.4 56.0901H94.95V43.5601H107.4V56.0901ZM98.93 52.0801H103.41V47.5701H98.93V52.0801Z"
              fill="#00B033"
            />
            <path
              d="M174.14 153.34H161.69V140.81H174.14V153.34ZM165.67 149.33H170.15V144.82H165.67V149.33Z"
              fill="#00B033"
            />
            <path
              d="M111.38 136.3H98.9301V123.77H111.38V136.3ZM102.91 132.29H107.39V127.78H102.91V132.29Z"
              fill="#00B033"
            />
            <path
              d="M36.67 149.33H24.22V136.8H36.67V149.33ZM28.2 145.32H32.68V140.81H28.2V145.32Z"
              fill="#00B033"
            />
            <path
              d="M176.13 244.58H163.68V232.05H176.13V244.58ZM167.66 240.57H172.14V236.06H167.66V240.57Z"
              fill="#00B033"
            />
            <path
              d="M150.19 333.37L125.06 326.63L132.38 322.38L128.42 315.74L121.57 327.34L105.38 317.75L118.99 294.64H138.54L148.84 312.56L156.36 306.88L150.19 333.36V333.37ZM135.4 325.25L147.25 328.43L149.98 316.72L147.64 318.49L137.36 300.61L130.74 311.82L137.89 323.8L135.4 325.24V325.25ZM110.84 316.33L120.17 321.85L133.88 298.64H121.25L110.84 316.32V316.33Z"
              fill="#00B033"
            />
            <path
              d="M143.07 381.14L123.47 362.41L141.94 343.98L141.89 352.49L149.58 352.4L143.09 340.59L159.49 331.36L172.44 354.85L162.57 371.83L142 371.73L143.07 381.13V381.14ZM129.2 362.35L137.86 370.63L137.53 367.71L158.05 367.81L151.78 356.4L137.89 356.56L137.91 353.67L129.2 362.36V362.35ZM148.5 342.15L161.48 365.78L167.85 354.81L157.94 336.84L148.49 342.16L148.5 342.15Z"
              fill="#00B033"
            />
            <path
              d="M121.15 371.59L94.4599 371.29L84.6899 354.25L94.9599 336.31L86.3099 332.59L112.18 324.73L118.94 350.01L111.62 345.75L107.89 352.52L121.3 352.69L121.15 371.6V371.59ZM96.7699 367.3L117.19 367.53L117.28 356.64L90.4599 356.29L96.7699 367.3ZM90.4099 352.28L103.37 352.45L110.11 340.23L112.59 341.67L109.4 329.75L97.9599 333.23L100.65 334.39L90.4099 352.28Z"
              fill="#00B033"
            />
            <path
              d="M125.82 52.1099L125.4 48.1199L131.98 47.4199L132.39 51.4099L125.82 52.1099Z"
              fill="#00B033"
            />
            <path
              d="M126.65 60.0799L126.23 56.0899L132.81 55.3999L133.23 59.3899L126.65 60.0799Z"
              fill="#00B033"
            />
            <path
              d="M132.49 61.8999L130.73 45.1199L142.97 43.8199L144.73 60.5999L132.49 61.8999ZM135.11 48.6799L136.03 57.4899L140.35 57.0299L139.43 48.2199L135.11 48.6799Z"
              fill="#00B033"
            />
            <path
              d="M158.97 112.28L157.78 100.87L169.68 99.61L170.87 111.02L158.97 112.28ZM162.16 104.44L162.52 107.88L166.5 107.46L166.14 104.02L162.16 104.44Z"
              fill="#00B033"
            />
            <path
              d="M164.54 125.42L162.86 109.31L166.82 108.89L168.09 121.02L189.23 118.77L186.2 89.86L155.49 93.11L152.88 68.19L190.43 64.2L188.87 49.25L143.39 54.07L142.97 50.08L192.41 44.84L194.81 67.77L157.26 71.76L159.04 88.71L189.75 85.45L193.61 122.34L164.54 125.42Z"
              fill="#00B033"
            />
            <path
              d="M89.49 141.87L0 115.31L15.69 86.41L19.18 88.33L5.87 112.87L85.56 136.52L85.86 108.25L89.84 108.29L89.49 141.87Z"
              fill="#00B033"
            />
            <path
              d="M83.2 125.27L13.72 104.92L19.21 93.97L83.11 112.93L83.21 125.26L83.2 125.27ZM19.43 102.42L79.17 119.91L79.14 115.94L21.26 98.76L19.43 102.42Z"
              fill="#00B033"
            />
            <path
              d="M66.97 63.84L60.35 61.87L61.48 58.03L68.09 59.99L66.97 63.84Z"
              fill="#00B033"
            />
            <path
              d="M51.9799 123.87L39.9399 120.29L41.0699 116.44L53.1099 120.02L51.9799 123.87Z"
              fill="#00B033"
            />
            <path
              d="M43.5163 52.2394L43.4827 56.2493L49.9024 56.3031L49.936 52.2932L43.5163 52.2394Z"
              fill="#00B033"
            />
            <path
              d="M41.99 66.75L38.18 65.6L39.23 62.07L37.6 59.07L41.1 57.15L43.52 61.62L41.99 66.75Z"
              fill="#00B033"
            />
            <path
              d="M41.64 63.8299L41.11 59.8599L46.97 59.0699L47.5 63.0499L41.64 63.8299Z"
              fill="#00B033"
            />
            <path
              d="M29.27 67.43L28.5 61.5L32.46 60.99L33.22 66.91L29.27 67.43Z"
              fill="#00B033"
            />
            <path
              d="M89.2 110.76L14.96 88.73L23.95 58.04L29.71 59.07L34.54 53.46L38.99 55.77L41.21 53.66L37.79 43.24L103.29 62.68L96.88 84.56L89.89 89.23L94.12 93.97L89.2 110.76ZM19.91 86.02L86.5 105.78L89.66 94.98L86.17 91.07L80.71 92.37L79.98 94.85L76.16 93.72L77.54 89.01L86.05 86.98L93.45 82.03L98.32 65.4L43.95 49.26L45.78 54.83L39.67 60.64L35.49 58.47L31.23 63.42L26.75 62.62L19.89 86.02H19.91Z"
              fill="#00B033"
            />
            <path
              d="M77.69 92.07L70.24 84.17L73.13 81.41L80.58 89.31L77.69 92.07Z"
              fill="#00B033"
            />
            <path
              d="M26.84 200.34L25.8 164.05L63.5401 162.95L64.59 199.24L26.84 200.34ZM29.9 167.94L30.72 196.21L60.5 195.34L59.68 167.07L29.9 167.94Z"
              fill="#00B033"
            />
            <path
              d="M34.22 192.47L33.64 172.32L56.19 171.66L56.77 191.81L34.22 192.47ZM37.74 176.21L38.09 188.34L52.68 187.91L52.33 175.78L37.74 176.21Z"
              fill="#00B033"
            />
            <path
              d="M32.9585 157.342L28.9801 157.457L29.2249 165.953L33.2032 165.838L32.9585 157.342Z"
              fill="#00B033"
            />
            <path
              d="M39.9399 157.142L35.9615 157.256L36.2063 165.753L40.1846 165.638L39.9399 157.142Z"
              fill="#00B033"
            />
            <path
              d="M46.8909 156.941L42.9126 157.056L43.1573 165.552L47.1357 165.438L46.8909 156.941Z"
              fill="#00B033"
            />
            <path
              d="M53.8523 156.741L49.8739 156.855L50.1186 165.352L54.097 165.237L53.8523 156.741Z"
              fill="#00B033"
            />
            <path
              d="M60.8136 156.54L56.8352 156.655L57.08 165.152L61.0583 165.037L60.8136 156.54Z"
              fill="#00B033"
            />
            <path
              d="M34.1567 198.98L30.1783 199.095L30.4231 207.591L34.4014 207.477L34.1567 198.98Z"
              fill="#00B033"
            />
            <path
              d="M41.1178 198.77L37.1394 198.884L37.3842 207.381L41.3625 207.266L41.1178 198.77Z"
              fill="#00B033"
            />
            <path
              d="M48.1091 198.559L44.1307 198.674L44.3755 207.17L48.3538 207.056L48.1091 198.559Z"
              fill="#00B033"
            />
            <path
              d="M55.0705 198.359L51.0922 198.474L51.3369 206.97L55.3153 206.855L55.0705 198.359Z"
              fill="#00B033"
            />
            <path
              d="M62.0116 198.159L58.0332 198.273L58.278 206.77L62.2563 206.655L62.0116 198.159Z"
              fill="#00B033"
            />
            <path
              d="M70.0558 165.315L61.6193 165.557L61.734 169.565L70.1706 169.324L70.0558 165.315Z"
              fill="#00B033"
            />
            <path
              d="M70.2564 172.317L61.8198 172.558L61.9346 176.567L70.3711 176.325L70.2564 172.317Z"
              fill="#00B033"
            />
            <path
              d="M70.4669 179.328L62.0304 179.57L62.1452 183.578L70.5817 183.336L70.4669 179.328Z"
              fill="#00B033"
            />
            <path
              d="M70.6675 186.339L62.231 186.581L62.3457 190.589L70.7823 190.348L70.6675 186.339Z"
              fill="#00B033"
            />
            <path
              d="M70.8677 193.341L62.4312 193.582L62.5459 197.591L70.9825 197.349L70.8677 193.341Z"
              fill="#00B033"
            />
            <path
              d="M28.6974 166.519L20.2609 166.76L20.3756 170.769L28.8122 170.527L28.6974 166.519Z"
              fill="#00B033"
            />
            <path
              d="M28.908 173.53L20.4714 173.771L20.5862 177.78L29.0227 177.538L28.908 173.53Z"
              fill="#00B033"
            />
            <path
              d="M29.1082 180.531L20.6716 180.773L20.7864 184.781L29.2229 184.54L29.1082 180.531Z"
              fill="#00B033"
            />
            <path
              d="M29.3087 187.543L20.8722 187.784L20.987 191.793L29.4235 191.551L29.3087 187.543Z"
              fill="#00B033"
            />
            <path
              d="M29.5093 194.554L21.0728 194.796L21.1875 198.804L29.6241 198.562L29.5093 194.554Z"
              fill="#00B033"
            />
            <path
              d="M50.32 259.22C49.39 259.22 48.45 259.07 47.53 258.77L41.79 256.88C37.11 255.34 34.54 250.25 36.07 245.54L40.42 232.14C41.16 229.86 42.74 228 44.87 226.91C47 225.82 49.42 225.64 51.69 226.38L57.43 228.27C62.11 229.81 64.68 234.9 63.15 239.61L58.8 253.01C58.06 255.29 56.48 257.15 54.35 258.24C53.08 258.89 51.7 259.22 50.32 259.22ZM48.92 229.94C48.15 229.94 47.39 230.12 46.69 230.48C45.51 231.08 44.64 232.11 44.22 233.38L39.87 246.78C39.02 249.39 40.44 252.21 43.04 253.06L48.78 254.95C50.04 255.37 51.38 255.26 52.56 254.66C53.74 254.06 54.61 253.03 55.03 251.76L59.38 238.36C60.23 235.75 58.81 232.93 56.21 232.08L50.47 230.19C49.96 230.02 49.44 229.94 48.93 229.94H48.92Z"
              fill="#00B033"
            />
            <path
              d="M52.44 240.34L48.65 239.09L50.51 233.37L54.3 234.62L52.44 240.34Z"
              fill="#00B033"
            />
            <path
              d="M136.06 126.07L120.18 121.6L120.82 119.62C121.36 117.93 121.74 115.06 121.06 114.11C118.47 110.48 118.44 102.31 122.3 96.8C124.15 94.15 128.35 90.16 136.18 91.8V91.75C136.46 91.82 136.72 91.9 136.98 91.98C137.24 92.05 137.5 92.12 137.77 92.19V92.24C145.3 94.93 146.83 100.53 147.05 103.76C147.51 110.48 143.27 117.45 139.19 119.2C138.1 119.67 136.96 122.31 136.55 124.04L136.07 126.07H136.06ZM125.12 118.83L133.27 121.12C133.98 119.18 135.34 116.49 137.62 115.51C140.06 114.47 143.42 109.19 143.07 104.03C142.8 100.03 140.39 97.28 135.91 95.84C131.34 94.72 127.86 95.82 125.56 99.1C122.6 103.33 122.76 109.59 124.3 111.76C125.74 113.78 125.52 116.79 125.13 118.83H125.12Z"
              fill="#00B033"
            />
            <path
              d="M134.87 133.03L117.6 128.17L120.55 117.55L137.82 122.41L134.87 133.03ZM122.51 125.39L132.1 128.09L132.9 125.19L123.31 122.49L122.5 125.39H122.51Z"
              fill="#00B033"
            />
            <path
              d="M128.79 134.44L122.08 132.55L123.95 125.79L130.67 127.68L128.79 134.44Z"
              fill="#00B033"
            />
            <path
              d="M134.24 109.67L126.33 101.61L134.47 98.9401L133.31 94.1401L137.18 93.1901L139.21 101.6L133.69 103.41L137.07 106.85L134.24 109.67Z"
              fill="#00B033"
            />
            <path
              d="M231.93 120.67L201.54 113.54L213.32 62.71L243.71 69.84L231.93 120.67ZM206.32 110.54L228.95 115.85L238.92 72.83L216.29 67.52L206.32 110.54Z"
              fill="#00B033"
            />
            <path
              d="M221.77 109.92L215.37 108.42L216.28 104.52L222.68 106.02L221.77 109.92Z"
              fill="#00B033"
            />
            <path
              d="M227.44 73.31L222.16 72.07L220.59 67.88L224.32 66.47L225.14 68.66L228.35 69.41L227.44 73.31Z"
              fill="#00B033"
            />
            <path
              d="M231.22 74.2L225.94 72.96L226.84 69.06L230.05 69.81L231.74 68.21L234.47 71.14L231.22 74.2Z"
              fill="#00B033"
            />
            <path
              d="M93.63 257.37L87.41 150.8L150.06 147.09L156.28 253.66L93.63 257.37ZM91.61 154.57L97.37 253.13L152.06 249.9L146.3 151.34L91.61 154.58V154.57Z"
              fill="#00B033"
            />
            <path
              d="M96.51 169.97L95.86 158.82L142.6 156.05L143.25 167.2L96.51 169.97ZM100.07 162.58L100.25 165.72L139.03 163.43L138.85 160.28L100.07 162.58Z"
              fill="#00B033"
            />
            <path
              d="M97.41 185.41L96.76 174.26L143.5 171.49L144.15 182.64L97.41 185.41ZM100.97 178.02L101.15 181.17L139.93 178.88L139.75 175.73L100.97 178.02Z"
              fill="#00B033"
            />
            <path
              d="M109.53 254.48L106.03 252.55L109.37 246.43L139.16 244.66L145.66 251.18L142.85 254.02L137.61 248.77L111.81 250.3L109.53 254.48Z"
              fill="#00B033"
            />
            <path
              d="M108.34 217.83L92.65 211.06L94.22 207.37L109.04 213.77L136.52 212.14L150.31 204.35L152.26 207.85L137.67 216.09L108.34 217.83Z"
              fill="#00B033"
            />
            <path
              d="M123.9 239.5C120.18 239.5 117.05 236.57 116.83 232.78C116.6 228.85 119.59 225.47 123.49 225.24C127.41 224.99 130.75 228.02 130.98 231.94C131.21 235.87 128.22 239.25 124.32 239.48C124.18 239.48 124.04 239.49 123.9 239.49V239.5ZM123.91 229.24C123.85 229.24 123.79 229.24 123.73 229.24C122.02 229.34 120.71 230.82 120.81 232.54C120.91 234.26 122.38 235.54 124.09 235.48C124.92 235.43 125.68 235.06 126.23 234.44C126.78 233.82 127.06 233.01 127.01 232.18C126.91 230.52 125.54 229.24 123.91 229.24Z"
              fill="#00B033"
            />
            <path
              d="M144.472 188.083L97.7314 190.81L97.9651 194.814L144.706 192.086L144.472 188.083Z"
              fill="#00B033"
            />
            <path
              d="M219.96 38.04H36.67V21H219.96V38.04ZM40.65 34.03H215.97V25.01H40.65V34.03Z"
              fill="#00B033"
            />
            <path
              d="M150.28 23H146.29V12.98H110.38V23H106.4V8.96997H150.28V23Z"
              fill="#00B033"
            />
            <path
              d="M162.27 23H158.28V4.01H98.74V23H94.76V0H162.27V23Z"
              fill="#00B033"
            />
          </svg>
        )}
        <div className="imagem-texto-varia-content">
          {data.title && <h2>{data.title}</h2>}
          {data.text && <p>{data.text}</p>}
          {data.highlight_text && (
            <p className="highlight-text">{data.highlight_text}</p>
          )}
          {data.show_button && data.button_text && (
            <button
              type="button"
              className="imagem-texto-varia-botao themed-button"
              onClick={() => {
                if (data.button_url) {
                  window.location.href = data.button_url;
                }
              }}
            >
              {data.button_text}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default View;
